import clsx from "clsx";
import { Loader2 } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  isLoading?: boolean;
}

const Button = ({ children, className, isLoading = false, type = "button", ...rest }: ButtonProps) => {
  const loadingClasses = isLoading ? "cursor-not-allowed opacity-70" : "";

  return (
    <button
      className={clsx(
        `${loadingClasses} bg-gradient-to-r from-purple-600 via-[#97B1FF] to-purple-600 text-white px-6 py-2 rounded-full font-medium relative overflow-hidden bg-[length:200%_100%] transition-[background-position] duration-1000 ease-out hover:bg-[position:100%_0] flex gap-2`,
        className,
      )}
      type={type}
      {...rest}
    >
      {isLoading ? (
        <span className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="inline-block">{children}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
